import lazyLoader from '@/shared/helpers/lazyLibraries';

export default {
  data() {
    return {
      libraries: {},
      libraryLoading: {},
    };
  },

  methods: {
    // Load specific asset file
    async loadAssetFile(fileName) {
      return lazyLoader.loadAssetFile(fileName);
    },

    // Generic library loader with caching and loading state
    async loadLibrary(libraryName, loaderFunction) {
      // Check cache first
      if (this.libraries[libraryName]) {
        return this.libraries[libraryName];
      }

      // Check if already loading
      if (this.libraryLoading[libraryName]) {
        return this.libraryLoading[libraryName];
      }

      // Create loading promise
      const loadPromise = loaderFunction().then(result => {
        this.libraries[libraryName] = result;
        delete this.libraryLoading[libraryName];
        return result;
      }).catch(error => {
        delete this.libraryLoading[libraryName];
        throw error;
      });

      // Store loading promise
      this.libraryLoading[libraryName] = loadPromise;
      return loadPromise;
    },

    // Load jsPDF library
    async loadJsPDF() {
      return this.loadLibrary('jspdf', () => lazyLoader.loadJsPDF());
    },

    // Load html2canvas library
    async loadHtml2Canvas() {
      return this.loadLibrary('html2canvas', () => lazyLoader.loadHtml2Canvas());
    },

    // Load fabric.js library
    async loadFabric() {
      return this.loadLibrary('fabric', () => lazyLoader.loadFabric());
    },

    // Load swiper library
    async loadSwiper() {
      return this.loadLibrary('swiper', () => lazyLoader.loadSwiper());
    },

    // Load multiple libraries at once
    async loadLibraries(...libraryNames) {
      const libraryMap = {
        jspdf: () => this.loadJsPDF(),
        html2canvas: () => this.loadHtml2Canvas(),
        fabric: () => this.loadFabric(),
        swiper: () => this.loadSwiper(),
      };

      const loadPromises = libraryNames.map(name => {
        const loader = libraryMap[name];
        if (!loader) {
          throw new Error(`Unknown library: ${name}`);
        }
        return loader();
      });

      return Promise.all(loadPromises);
    },

    // Get cache info
    getCacheInfo() {
      return lazyLoader.getCacheInfo();
    },

    // Clear cache
    clearCache() {
      lazyLoader.clearAllCache();
      this.libraries = {};
      this.libraryLoading = {};
    },

    // Check if library is loading
    isLibraryLoading(libraryName) {
      return !!this.libraryLoading[libraryName];
    },

    // Clear library cache
    clearLibraryCache(libraryName) {
      if (libraryName) {
        delete this.libraries[libraryName];
        delete this.libraryLoading[libraryName];
        lazyLoader.clearCache(libraryName);
      } else {
        this.libraries = {};
        this.libraryLoading = {};
        lazyLoader.clearAllCache();
      }
    },
  },
};
